import { motion } from "framer-motion";
import { MANIFESTO } from "../../data/content";

export const Manifesto = () => {
  return (
    <section
      data-testid="manifesto-section"
      className="relative bg-background py-24 md:py-40"
    >
      <div className="mx-auto max-w-[1600px] px-6 md:px-10">
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7 }}
          className="font-mono-ibm text-xs tracking-widest uppercase text-primary mb-16 md:mb-24"
        >
          / The Doctrine
        </motion.p>

        <div className="space-y-20 md:space-y-32">
          {MANIFESTO.map((m, i) => (
            <motion.div
              key={m.no}
              initial={{ opacity: 0, y: 60 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-100px" }}
              transition={{ duration: 0.9, ease: [0.76, 0, 0.24, 1] }}
              className={`grid md:grid-cols-12 gap-6 md:gap-10 items-start ${
                i % 2 === 1 ? "md:pl-[16%]" : ""
              }`}
            >
              <div className="md:col-span-2">
                <span className="font-mono-ibm text-sm tracking-widest text-muted-foreground">
                  {m.no}
                </span>
              </div>
              <div className="md:col-span-10">
                <h3 className="font-display uppercase leading-[0.9] tracking-tight text-4xl md:text-6xl lg:text-7xl mb-6">
                  {m.title}
                </h3>
                <p className="max-w-2xl text-base md:text-lg text-muted-foreground leading-relaxed">
                  {m.body}
                </p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
